// Desktop Dev Chat Context Options
// Context size (auto | manual min/max) and context allocation (auto | manual number)

import React from 'react';
import { DropdownSelect, RevoltInput, RevoltSwitch } from '../../../../../components';
import './DesktopDevChatContextOptions.css';

const CONTEXT_SIZE_OPTIONS = [
  { value: 'auto', label: 'Auto' },
  { value: 'manual', label: 'Manual' },
];

const CONTEXT_ALLOCATION_OPTIONS = [
  { value: 'auto', label: 'Auto' },
  { value: 'manual', label: 'Manual' },
];

export function DesktopDevChatContextOptions({
  contextSizeMode = 'auto',
  contextSizeMin = 2048,
  contextSizeMax = 4096,
  contextAllocationMode = 'auto',
  contextAllocationSize = 4096,
  defaultContextFlashAttention = false,
  onDefaultContextFlashAttentionChange,
  onContextSizeModeChange,
  onContextSizeMinChange,
  onContextSizeMaxChange,
  onContextAllocationModeChange,
  onContextAllocationSizeChange,
  onContextOptionsCommit,
  disabled = false,
}) {
  const contextSizeManual = contextSizeMode === 'manual';
  const contextAllocationManual = contextAllocationMode === 'manual';

  const handleInputCommit = (e) => {
    if (e.type === 'keydown' && e.key !== 'Enter') return;
    onContextOptionsCommit?.();
  };

  return (
    <div className="desktop-dev-chat-context-options">
      <div className="desktop-dev-chat-context-option desktop-dev-chat-context-advanced">
        <RevoltSwitch
          id="dev-chat-flash-attention"
          checked={defaultContextFlashAttention}
          onChange={onDefaultContextFlashAttentionChange}
          label="Flash attention"
          disabled={disabled}
          title="Enable default context flash attention when loading the model (node-llama-cpp loadModel). Improves attention performance on supported GPU builds; turn off to compare or if you hit compatibility issues."
        />
      </div>
      <div className="desktop-dev-chat-context-option desktop-dev-chat-context-size">
        <label className="desktop-dev-chat-context-label">Context size</label>
        <div className="desktop-dev-chat-context-row">
          <DropdownSelect
            id="dev-chat-context-size-mode"
            value={contextSizeMode}
            options={CONTEXT_SIZE_OPTIONS}
            onValueChange={onContextSizeModeChange}
            disabled={disabled}
            size="sm"
            className="desktop-dev-chat-context-mode-select"
          />
          {contextSizeManual && (
            <>
              <RevoltInput
                type="number"
                min={512}
                max={128000}
                step={256}
                value={contextSizeMin}
                onChange={(e) => onContextSizeMinChange?.(e.target.value)}
                onBlur={handleInputCommit}
                onKeyDown={handleInputCommit}
                disabled={disabled}
                size="sm"
                className="desktop-dev-chat-context-input"
                placeholder="Min"
                title="Min context tokens"
              />
              <span className="desktop-dev-chat-context-sep">–</span>
              <RevoltInput
                type="number"
                min={512}
                max={128000}
                step={256}
                value={contextSizeMax}
                onChange={(e) => onContextSizeMaxChange?.(e.target.value)}
                onBlur={handleInputCommit}
                onKeyDown={handleInputCommit}
                disabled={disabled}
                size="sm"
                className="desktop-dev-chat-context-input"
                placeholder="Max"
                title="Max context tokens"
              />
            </>
          )}
        </div>
      </div>

      <div className="desktop-dev-chat-context-option desktop-dev-chat-context-allocation">
        <label className="desktop-dev-chat-context-label">Context allocation</label>
        <div className="desktop-dev-chat-context-row">
          <DropdownSelect
            id="dev-chat-context-allocation-mode"
            value={contextAllocationMode}
            options={CONTEXT_ALLOCATION_OPTIONS}
            onValueChange={onContextAllocationModeChange}
            disabled={disabled}
            size="sm"
            className="desktop-dev-chat-context-mode-select"
          />
          {contextAllocationManual && (
            <RevoltInput
              type="number"
              min={256}
              max={128000}
              step={256}
              value={contextAllocationSize}
              onChange={(e) => onContextAllocationSizeChange?.(e.target.value)}
              onBlur={handleInputCommit}
              onKeyDown={handleInputCommit}
              disabled={disabled}
              size="sm"
              className="desktop-dev-chat-context-input"
              placeholder="Size"
              title="Context allocation size (tokens)"
            />
          )}
        </div>
      </div>
    </div>
  );
}
